// Unchanged.
import type { ReactNode } from 'react'

export function ErrorNotice({ children }: { children: ReactNode }) {
  return <div role="alert" className="mb-5 rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-700">{children}</div>
}

export function LoadingBlock({ label }: { label: string }) {
  return <div className="rounded-2xl border border-gray-300 bg-white p-10 text-center text-sm text-gray-600">{label}</div>
}

/** Shown where a figure could not be loaded. A missing measurement is never rendered as zero. */
export const UNAVAILABLE = '—'
